module.exports = __webpack_public_path__ + "img/order-step10-c.803a08d2.png";